import React, { useState } from "react";
import "./index.css";
import "./components/assets/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Onboard from "./components/tabs/Onboard";
import Create from "./components/tabs/Create";
import Repository from "./components/tabs/Details";


function App() {
  const [selectedTab, setSelectedTab] = useState("Onboard/License");
  //const [userName, setUserName] = useState("");
  const [userName, setUserName] = useState("Srivatsa Srinath Murthy");

  const renderTabContent = () => {
    switch (selectedTab) {
      case "Onboard/License":
        return <Onboard tab="License" />;
      case "Onboard/Delta MBN":
        return <Onboard tab="Delta MBN" />;
      case "Repository/License":
        return <Repository tab="License" />;
      case "Repository/Delta MBN":
        return <Repository tab="Delta MBN" />;
      case "Repository/Created Solution":
        return <Repository tab="Created Solution" />;
      case "Repository/Certified Solution":
        return <Repository tab="Certified Solution" />;
      case "Repository/Delivery Ready Solution":
        return <Repository tab="Delivery Ready Solution" />;
      case "Create/Group":
        return <Create tab="Group" />;
      case "Create/Solution":
        return <Create tab="Solution" />;
      default:
        return <Onboard tab="License" />;
    }
  }

    return (
      <div className="App">
        <Header 
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          userName={userName}
        />

        <div className="body">
          <div className="tab-body">{renderTabContent()}</div>
        </div>
        <Footer className="footer" />
      </div>
    );
};

export default App;
